import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useUserActivity = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const trackActivity = async () => {
      try {
        await supabase.from('user_actions').insert({
          user_id: user.id,
          action: 'page_view',
          page_url: window.location.pathname,
          session_id: sessionStorage.getItem('session_id') || crypto.randomUUID(),
          details: {
            timestamp: new Date().toISOString(),
            user_agent: navigator.userAgent,
          }
        });

        // Store session ID
        if (!sessionStorage.getItem('session_id')) {
          sessionStorage.setItem('session_id', crypto.randomUUID());
        }
      } catch (error) {
        console.error('Error tracking activity:', error);
      }
    };

    trackActivity();

    // Track every 30 seconds of activity
    const interval = setInterval(trackActivity, 30000);

    return () => clearInterval(interval);
  }, [user, window.location.pathname]);
};
